import { UtilitiesService } from 'src/app/services/utilities.service';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localizedLabel',
})
export class LocalizedLabelPipe implements PipeTransform {
  constructor(private readonly utilitiesService: UtilitiesService) {}

  public transform(item: unknown, label: string): string {
    let localizedLabel = '';

    if (item && label) {
      localizedLabel = this.utilitiesService.getLocalizedLabel(item, label);
    }

    return localizedLabel;
  }
}
